var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.userAreaIsGarantia)?_c('NewQuotationGarantia'):_vm._e(),(_vm.userAreaIsAgro)?_c('NewQuotationAgro'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }